import React, { useState } from 'react';
import { SearchIcon, HomeIcon, FileTextIcon, DollarSignIcon, BriefcaseIcon, WalletIcon, ClipboardListIcon, LockIcon, BuildingIcon, TruckIcon, PencilIcon, BoxIcon, ShieldIcon, AnchorIcon, AwardIcon, ScrollTextIcon, IdCardIcon, ReceiptIcon } from 'lucide-react';
import { StatusCard } from './components/StatusCard';
import { SelectionScreen } from './components/SelectionScreen';
import { DocType, PropertyType } from './types/loan';
interface CardConfig {
  title: string;
  icon: BoxIcon;
  statusLabels?: {
    red?: string;
    yellow?: string;
    green?: string;
  };
  dateLabels?: {
    red?: string;
    yellow?: string;
    green?: string;
  };
}
const CLOSING_DISCLOSURE_CARD: CardConfig = {
  title: 'Closing Disclosure',
  icon: ClipboardListIcon,
  statusLabels: {
    yellow: 'Disclosed',
    green: 'Signed'
  }
};
const RATE_LOCK_CARD: CardConfig = {
  title: 'Rate Lock',
  icon: LockIcon,
  statusLabels: {
    red: 'Not Locked',
    yellow: 'Pending',
    green: 'Locked'
  },
  dateLabels: {
    yellow: 'Requested',
    green: 'Locked'
  }
};
function getPropertyCards(propertyType: PropertyType): CardConfig[] {
  if (propertyType === 'Condo') {
    return [{
      title: 'Master Policy',
      icon: ShieldIcon
    }];
  }
  if (propertyType === 'Manufactured') {
    return [{
      title: 'Affidavit of Affixture',
      icon: AnchorIcon
    }];
  }
  return [];
}
function getCards(docType: DocType, propertyType: PropertyType): CardConfig[] {
  let docCards: CardConfig[] = [];
  if (docType === 'Full Doc') {
    docCards = [{
      title: 'Appraisal',
      icon: FileTextIcon
    }, {
      title: 'Income',
      icon: BriefcaseIcon
    }, {
      title: 'Assets',
      icon: WalletIcon
    }, {
      title: 'Title',
      icon: SearchIcon
    }, {
      title: 'HOI',
      icon: HomeIcon
    }, {
      title: 'Payoff',
      icon: DollarSignIcon
    }];
  } else if (docType === 'IRRRL') {
    docCards = [{
      title: 'IRRRL Cert',
      icon: AwardIcon
    }, {
      title: 'HOI',
      icon: HomeIcon
    }, {
      title: 'Payoff',
      icon: DollarSignIcon
    }, {
      title: 'Title',
      icon: SearchIcon
    }];
  } else if (docType === 'FHA Streamline') {
    docCards = [{
      title: 'HOI',
      icon: HomeIcon
    }, {
      title: 'Payoff',
      icon: DollarSignIcon
    }, {
      title: 'Title',
      icon: SearchIcon
    }, {
      title: 'Mortgage Note',
      icon: ScrollTextIcon
    }, {
      title: 'SSA-89',
      icon: IdCardIcon
    }, {
      title: 'Utility Bill',
      icon: ReceiptIcon
    }, {
      title: 'Assets',
      icon: WalletIcon
    }];
  }
  return [...docCards, ...getPropertyCards(propertyType), CLOSING_DISCLOSURE_CARD, RATE_LOCK_CARD];
}
export function App() {
  const [docType, setDocType] = useState<DocType | null>(null);
  const [propertyType, setPropertyType] = useState<PropertyType | null>(null);
  if (!docType || !propertyType) {
    return <SelectionScreen onContinue={(d, p) => {
      setDocType(d);
      setPropertyType(p);
    }} data-id="element-0" />;
  }
  const cards = getCards(docType, propertyType);
  return <div className="w-full min-h-screen bg-slate-50 p-4" data-id="element-1">
      <div className="flex items-center justify-between mb-4" data-id="element-2">
        <div className="flex items-center gap-2 text-sm" data-id="element-3">
          <span className="rounded-full bg-teal-100 text-teal-800 px-2.5 py-1 text-xs font-semibold" data-id="element-4">
            {docType}
          </span>
          <span className="rounded-full bg-slate-100 text-slate-700 px-2.5 py-1 text-xs font-semibold" data-id="element-5">
            {propertyType}
          </span>
        </div>
        <button type="button" onClick={() => {
        setDocType(null);
        setPropertyType(null);
      }} className="flex items-center gap-1.5 text-xs font-medium text-slate-600 hover:text-slate-900" data-id="element-6">
          <PencilIcon className="h-3.5 w-3.5" data-id="element-7" />
          Change
        </button>
      </div>

      <div className="flex flex-nowrap gap-2 items-start w-full" data-id="element-8">
        {cards.map(c => <StatusCard key={c.title} title={c.title} icon={c.icon} statusLabels={c.statusLabels} dateLabels={c.dateLabels} data-id="element-9" />)}
      </div>
    </div>;
}